import { createUseStyles, ComposedTheme } from '@glu/theming';
import { IActionableMenuIconProps } from './ActionableMenuIcon';

const styles = ({
  icons: {
    actionableIcon: {
      hoverBackgroundColor: actionableIconHoverBackgroundColor,
      hoverColor: actionableIconHoverColor,
    },
    actionableMenuIcon: {
      menuBackgroundColor,
      menuBorder,
      menuBorderRadius,
      menuFontSize,
      menuPadding,
    },
  },
}: ComposedTheme) => ({
  root: {
    position: 'relative',
  },
  left: {},
  right: {},
  menu: {
    '&$left': {
      left: 0,
    },
    '&$right': {
      right: 0,
    },
    backgroundClip: 'padding-box',
    backgroundColor: menuBackgroundColor,
    border: menuBorder,
    borderRadius: menuBorderRadius,
    fontSize: menuFontSize,
    margin: [2, 0, 0, 0],
    minWidth: ({ minWidth }: { minWidth: IActionableMenuIconProps['minWidth'] }) =>
      minWidth || undefined,
    padding: menuPadding,
    position: 'absolute',
    textAlign: 'left',
    top: '100%',
    zIndex: 1000,
  },
  openMenuIcon: {
    background: actionableIconHoverBackgroundColor,
    borderRadius: 32,

    '&$openMenuIcon svg': {
      fill: actionableIconHoverColor,
    },
  },
});

export default createUseStyles(styles);
